import { Component } from '@angular/core';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatButton, MatButtonModule, MatIconButton} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'app-pending-manual-transfer',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIconButton,
    MatDialogModule, MatButtonModule, MatIconModule
  ],
  templateUrl: './pending-manual-transfer.component.html',
  standalone: true,
  styleUrl: './pending-manual-transfer.component.scss'
})
export class PendingManualTransferComponent {

}
